import React from "react";
import { PAYMENT_BUTTON_STYLES } from "utilities/onlinePaymentFlow";

const PaymentModeButtons = ({ buttons = [], onSelect, layout = "auto" }) => {
  const useRow =
    layout === "row" || (layout === "auto" && buttons.length > 1);

  return (
    <div
      className={
        useRow
          ? "grid grid-cols-2 gap-3"
          : "grid grid-cols-1 gap-3"
      }
    >
      {buttons.map((button) => {
        const styles =
          PAYMENT_BUTTON_STYLES[button.variant] ||
          PAYMENT_BUTTON_STYLES.upi;

        return (
          <button
            key={button.key}
            type="button"
            className="group flex items-center justify-center gap-2.5 rounded-xl px-4 py-3.5 text-white font-semibold text-sm transition-transform duration-150 hover:scale-[1.02] active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-400"
            style={{
              background: styles.background,
              boxShadow: styles.shadow,
            }}
            onClick={() =>
              onSelect?.(
                button.allowedPaymentMode,
                button.payMode,
                button
              )
            }
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/20 backdrop-blur-sm">
              <img
                src={button.icon}
                alt=""
                className="h-6 w-6 object-contain"
              />
            </span>
            <span className="tracking-wide">{button.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default PaymentModeButtons;
